import type { ReactNode } from "react";

import type { Permission } from "./permissions";
import { useAuth } from "./useAuth";

type Props = {
  /** Single required permission. */
  permission?: Permission;
  /** OR — any of these. */
  any?: Permission[];
  /** AND — all of these. */
  all?: Permission[];
  children: ReactNode;
  fallback?: ReactNode;
};

/** Renders children only if the auth user satisfies the permission rule. */
export function Guard({ permission, any, all, children, fallback = null }: Props) {
  const { user } = useAuth();
  const held = user?.permissions ?? [];

  let allowed = true;
  if (permission) allowed = allowed && held.includes(permission);
  if (any) allowed = allowed && any.some((p) => held.includes(p));
  if (all) allowed = allowed && all.every((p) => held.includes(p));

  return <>{allowed ? children : fallback}</>;
}
